import { render, staticRenderFns } from "./downloadBusiness.vue?vue&type=template&id=87adb180&scoped=true"
import script from "./downloadBusiness.vue?vue&type=script&lang=js"
export * from "./downloadBusiness.vue?vue&type=script&lang=js"
import style0 from "./downloadBusiness.vue?vue&type=style&index=0&id=87adb180&prod&lang=css"
import style1 from "./downloadBusiness.vue?vue&type=style&index=1&id=87adb180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87adb180",
  null
  
)

export default component.exports